export const headerStyles = {
	backgroundColor: 'backgrounds.white',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	boxShadow: 'none',
	borderBottom: '1px solid',
	borderColor: 'neutrals.primary',
};

export const toolbarStyles = {
	justifyContent: 'space-between',
	width: '100%',
	padding: '1.25rem 2.5rem',
	maxHeight: '5rem',
};

export const toolbarWrapStyles = {
	width: '100%',
	display: 'grid',
	gridTemplateColumns: 'auto 1fr auto',
	gridTemplateRows: 'auto',
	alignItems: 'center',
	gap: '1rem',
};

export const logoStyles = {
	width: { xs: '116px', md: '116px', xl: '200px' },
	maxWidth: '100%',
	cursor: 'pointer',
	'&:hover': { opacity: 0.8 },
};

export const navigationStyles = {
	display: 'flex',
	flexFlow: 'row nowrap',
	gap: { xs: '0', lg: '1.5%', xl: '1rem' },
};

export const navigationLinkStyles = {
	padding: 0,
	display: 'inline-flex',
	alignItems: 'center',
};
